import React, { useEffect, useState } from "react";
import { faPlus, faCodeBranch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useVersions } from "../queries/use-versions";
import CreateVersionPopup from "./CreateVersionPopup";
import { usePermission } from "../context/PermissionContext";

const VersionsDropDown = ({ projectId, versionId, setVersionId }) => {
  const { data = [] } = useVersions(projectId);
  const [showCreateForm, setShowCreateForm] = useState(false);
  const { hasAdminRight } = usePermission();

  useEffect(() => {
    if (versionId === null && data.length > 0) {
      setVersionId(data[0].id);
    }
  }, [versionId, data, setVersionId]);

  return (
    <div className="flex items-center gap-2">
      <div className="relative inline-flex items-center rounded-full border border-gray-200 bg-white pl-3 pr-2 h-9 shadow-sm hover:border-gray-300 transition">
        <FontAwesomeIcon
          icon={faCodeBranch}
          className="w-3.5 h-3.5 text-gray-400 mr-2"
        />
        <select
          value={versionId ?? ""}
          className="appearance-none bg-transparent pr-6 text-sm text-gray-700 focus:outline-none cursor-pointer"
          onChange={(e) => setVersionId(e.target.value)}
        >
          {data.map((d) => (
            <option key={d.id} value={d.id}>
              {d.name}
            </option>
          ))}
        </select>
        <span className="pointer-events-none absolute right-3 text-gray-400 text-xs">
          ▾
        </span>
      </div>
      {hasAdminRight && (
        <button
          type="button"
          className="inline-flex items-center gap-1.5 h-9 px-3 rounded-full bg-yellow-500 text-white text-xs font-semibold shadow-sm hover:opacity-95 transition"
          onClick={() => setShowCreateForm(true)}
          title="Add version"
        >
          <FontAwesomeIcon icon={faPlus} className="w-3 h-3" />
          Add version
        </button>
      )}
      {showCreateForm && (
        <CreateVersionPopup
          projectId={projectId}
          onClose={() => setShowCreateForm(false)}
          onCreate={(id) => {
            setShowCreateForm();
            setVersionId(id);
          }}
        />
      )}
    </div>
  );
};

export { VersionsDropDown };
